import { openDB } from 'idb';

const DB_NAME = 'cachedb';
const DB_VERSION = 1;

// Inicializa la base de datos y crea el almacén si no existe
const initDB = async (dbKey) => {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(dbKey)) {
        db.createObjectStore(dbKey);
      }
    },
  });
};

// Recupera los datos
export const getDataFromDB = async (key, dbKey) => {
  const db = await initDB(dbKey);
  return db.get(dbKey, key);
};

// Guarda los datos
export const storeDataInDB = async (key, data, dbKey) => {
  const db = await initDB(dbKey);
  await db.put(dbKey, data, key);
};

// Método para borrar todas las claves
export const clearAllData = async (dbKey) => {
    const db = await initDB();
    await db.clear(dbKey);    
};